<div class="wrapper">
  <div [ngClass]="{'button': true, 'arrow-right': arrowRight}" (click)="isOpen = !isOpen">
    <span [ngClass]="{'bold-text': boldTitle}" [innerHTML]="title"></span>
    <img [ngClass]="{'arrow-logo': true, 'revert': isOpen}">
  </div>
  <div class="content" [innerHTML]="description" *ngIf="isOpen" [@dropDown]></div>
</div>
